"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/PoundSign.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var PoundSign = function PoundSign(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 208.2 208.2"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Pound Icon"), _react2.default.createElement("g", {
    className: "pound-sign",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "outer-circle",
    d: "M104.1 0a104.1 104.1 0 1 0 104.1 104.1A104.28 104.28 0 0 0 104.1 0zm0 198.7a94.6 94.6 0 1 1 94.6-94.6 94.6 94.6 0 0 1-94.6 94.6z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "inner-circle",
    d: "M104.1 18.5a85.6 85.6 0 1 0 85.6 85.6 85.63 85.63 0 0 0-85.6-85.6zm0 168.4a82.8 82.8 0 1 1 82.8-82.8 83 83 0 0 1-82.8 82.8z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "pound",
    d: "M70.4 99.7a5.58 5.58 0 0 1 1.3-3.7 4.72 4.72 0 0 1 3.9-1.5h6.6V79.9A34.88 34.88 0 0 1 84 68.8a25.74 25.74 0 0 1 5.3-9.2 25.1 25.1 0 0 1 8.9-6.2 31.52 31.52 0 0 1 12.5-2.3 28.86 28.86 0 0 1 8.8 1.3 25.24 25.24 0 0 1 7 3.4 25.64 25.64 0 0 1 5.3 5.1 37.71 37.71 0 0 1 3.9 6.4l-6.1 3.9a8.57 8.57 0 0 1-4.1 1 5.27 5.27 0 0 1-3.6-2c-.8-.9-1.6-1.7-2.3-2.5a15 15 0 0 0-2.4-2 10.76 10.76 0 0 0-2.9-1.3 14.72 14.72 0 0 0-3.6-.4c-4.3 0-7.4 1.4-9.6 4.2S98 74.9 98 79.8v14.7h25.4v6.1a4.11 4.11 0 0 1-4.3 3.9H98v12a18.35 18.35 0 0 1-1.5 7.3 20.17 20.17 0 0 1-4.1 5.9c1.5-.3 3-.6 4.5-.8a35.53 35.53 0 0 1 4.6-.3h36.3v6.4a5.93 5.93 0 0 1-.5 2.3 7.43 7.43 0 0 1-1.3 2.1 6.52 6.52 0 0 1-2.1 1.6 6.6 6.6 0 0 1-2.7.6H71.7V132a19 19 0 0 0 4-1.4 15.65 15.65 0 0 0 3.4-2.3 9.38 9.38 0 0 0 2.3-3.3 11.17 11.17 0 0 0 .9-4.4v-16.2H70.4v-4.7z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: undefined
  })));
};
exports.default = PoundSign;